import container from "@/lib/di/container";
import { Suspense, useEffect, useState } from "react";
import { DetailModal } from "./modals/DetailModal";
import { Button, message, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { FeeLadderLevelModel, FeeLadderLevelModelFactory } from "@/core/models/fee-ladder-level.model";
import { FeeLadderLevelRepo } from "@/core/repos/tables/fee-ladder-level.repo";
import { FeeLadderRepo } from "@/core/repos/tables/fee-ladder.repo";
import { formatCurrencyPipe } from "@/core/pipes/format-currency.pipe";
import { cubicMeterPipe } from "@/core/pipes/unit.pipe";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { useSearchParams } from "react-router";
import { FilterInputTemplate, FilterBar } from "@/app/home/components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "@/app/home/components/table/DataTable";
import { DeleteButton } from "@/app/home/components/table/DeleteButton";


const feeLadderLevelRepo = container.get(FeeLadderLevelRepo);
const feeLadderRepo = container.get(FeeLadderRepo);

function FeeLadderLevel() {
    const [searchParams] = useSearchParams();
    const titleData = useTitleDataStore(); 
    const feeLadderId = searchParams.get('id');
    const [modalData, setModalData] = useState<FeeLadderLevelModel>(FeeLadderLevelModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<FeeLadderLevelModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        // {
        //     dataIndex: "search",
        //     label: "Tìm kiếm",
        //     placeholder: "Nhập nội dung tìm kiếm",
        //     type: FilterInputType.text,
        // },
    ])

    const showDetail = (record: FeeLadderLevelModel) => {
        console.log(record);
        setModalData(record);
        setDetailModal(true);
    };

    const init = async () => {
        titleData.setTitleBack(true);
        if (feeLadderId) {
            const feeLadder = await feeLadderRepo.detail(feeLadderId);
            if (feeLadder) {
                titleData.setTitleText(feeLadder.name)
                titleData.setTitleActions({
                    text: "Thêm bậc giá",
                    onPress: () => {
                        showDetail(FeeLadderLevelModelFactory.getEmpty(feeLadder))
                    }
                })
            }
        }
    }

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await feeLadderLevelRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: FeeLadderLevelModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-2">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected} noGap/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<FeeLadderLevelModel>
                columns={[
                    { dataIndex: 'name', name: 'Tên' },
                    { dataIndex: 'fromAmount', name: 'Chỉ số từ', pipe: cubicMeterPipe },
                    { dataIndex: 'toAmount', name: 'Chỉ số đến', pipe: cubicMeterPipe },
                    { dataIndex: 'price', name: 'Giá bán', pipe: formatCurrencyPipe },
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Sửa Bậc giá"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                </div>
                            ),
                        fixed: "right"
                    }
                ]}
                repository={feeLadderLevelRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
                defaultParams={{feeLadderId}}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}

export default function FeeLadderLevelPage() {
    return <Suspense>
        <FeeLadderLevel />
    </Suspense>
}